import Navbar from "../../components/Navbar/Navbar";
import Footer from '../../components/Footer/Footer';
import ContactForm from '../../components/ContactForm/ContactForm';
import BackToTop from '../../components/BackToTop/BackToTop';
import PageHeader from "../../components/PageHeader/PageHeader";
import maizeImg from '../../assets/images/programs/training/maize.png';

export default function Contact() {
    return (
        <>
            <Navbar />
            <PageHeader title="Contact Us" path="contact" name="Contact" backgroundImage={maizeImg} />
            <ContactForm />
            <Footer />
            <BackToTop />
        </>
    );
}